module.exports = __webpack_public_path__ + "static/img/5.bc184fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/5.png
// module id = ru8U
// module chunks = 0